import { type FC } from 'react'
import { TrialTimeline } from '../../Common/TrialTimeline'
import { type DeltaTrialTimelineProps } from '../Timeline/DeltaTrialTimeline'

export const createAppIntegrationTimeline = (name: string): FC<DeltaTrialTimelineProps> => {
  return (props) => <TrialTimeline featureName={`the ${name} Integration`} {...props} />
}
